import React, { useState } from 'react'
import {
  Modal,
  Header,
  Form,
  Radio,
  CheckboxProps,
} from 'semantic-ui-react'
import { observer } from '../../stores'
import i18n from '../../translations/i18n'
import { VAULTURE_LANGUAGE_PREF } from '../../utils/constants'

interface UserMenuModalProps {
  isOpen: boolean
  onClose: () => void
}

const UserMenuModal = observer(({ isOpen, onClose }: UserMenuModalProps) => {
  const [selected, setSelected] = useState(i18n.language)

  const onLanguageChange = (
    _: React.FormEvent<HTMLInputElement>,
    data: CheckboxProps,
  ) => {
    i18n.changeLanguage(data.value as any)
    setSelected(data.value as any)
    localStorage.setItem(VAULTURE_LANGUAGE_PREF, data.value as any)
  }

  return (
    <Modal open={isOpen} onClose={onClose} closeIcon size="small">
      <Header icon="globe" content="Select Language" />
      <Modal.Content>
        <Form>
          <Form.Field>
            <Radio
              label="English"
              name="English"
              value="en"
              checked={selected === 'en'}
              onChange={onLanguageChange}
            />
          </Form.Field>
          <Form.Field>
            <Radio
              label="中文"
              name="Chinese"
              value="ch"
              checked={selected === 'ch'}
              onChange={onLanguageChange}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
    </Modal>
  )
})

export default UserMenuModal
